import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "expand-wrapper" }
const _hoisted_2 = { class: "expand-wrapper__content" }


export default /*@__PURE__*/_defineComponent({
  __name: 'TransitionExpand',
  props: {
    show: { type: Boolean },
    direction: {}
  },
  emits: ["after-enter", "after-leave"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    name: `expand-${__props.direction}`,
    onAfterEnter: _cache[0] || (_cache[0] = ($event: any) => (emit('after-enter'))),
    onAfterLeave: _cache[1] || (_cache[1] = ($event: any) => (emit('after-leave')))
  }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ], 512), [
        [_vShow, __props.show]
      ])
    ]),
    _: 3
  }, 8, ["name"]))
}
}

})